import React from 'react';
import { useTranslation } from 'react-i18next';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import ContactForm from '../ContactForm';
import Section from '../Section';
import ContactInfoSection from '../Section/ContactInfoSection';
import WhatsAppButton from '../WhatsAppButton';
import { pageTitle } from '../../helpers/PageTitle';

export default function Contact() {
  const { t } = useTranslation();
  pageTitle(t('navigation.contact'));
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        imgUrl="/images/contact/vieux-infirmiere.png"
        title={t('contact.banner.title')}
        subTitle={t('contact.banner.subTitle')}
      />
      <div className="container cs_mt_minus_110">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <ContactForm />
          </div>
        </div>
      </div>
      <Section
        topMd={200}
        topLg={150}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <ContactInfoSection sectionTitle={t('contact.section.title')} />
      </Section>
      
      {/* WhatsApp Button */}
      <WhatsAppButton />
    </>
  );
}
